import { render } from "./SectionDividerEditor.vue?vue&type=template&id=1d98dfcd&scoped=true"
import script from "./SectionDividerEditor.vue?vue&type=script&lang=js"
export * from "./SectionDividerEditor.vue?vue&type=script&lang=js"

import "./SectionDividerEditor.vue?vue&type=style&index=0&id=1d98dfcd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d98dfcd"]])

export default __exports__